<template>
  <nav
    ref="combatNavBar"
    class="navbar-expand-lg bb-navbar"
  >
    <!---------------->
    <!-- CONTAINER  -->
    <!---------------->
    <div
      class="row align-items-center text-center bb-combat-navbar"
      :class="{ orange: isNotCurrent }"
    >
      <!---------------->
      <!--    LOGO    -->
      <!---------------->
      <div class="col-md-1">
        <router-link
          class="navbar-brand px-3"
          :to="{ name: 'campaignsView' }"
        >
          <img src="/bbLogo64Blue.png" />
        </router-link>
      </div>
      <!---------------->
      <!-- SCOREBOARD -->
      <!---------------->
      <div class="col-md-10">
        <score-board
          :view_round_value="view_round"
          :combat_round_value="arena_round"
        >
          <template v-slot:arena_status>
            {{ arena_status }}
          </template>
          <template v-slot:arena_sub_status>
            {{ arena_sub_status }}
          </template>
          <template v-slot:arena_locked>
            {{ arena_locked_label }}
          </template>
          <template v-slot:active_combatants>
            {{ arena_active_combatants }}
          </template>
          <template v-slot:inactive_combatants>
            {{ arena_inactive_combatants }}
          </template>
          <template v-slot:combat_round>
            {{ arena_round }}
          </template>
          <template v-slot:combat_action>
            {{ arena_action }}
          </template>
          <template v-slot:view_round>
            {{ view_round }}
          </template>
          <template v-slot:unused_action_count>
            {{ unused_action_count }}
          </template>
          <template v-slot:which_round>
            {{ which_round }}
          </template>
        </score-board>
      </div>
      <!------------------>
      <!-- MENU         -->
      <!------------------>
      <div class="col-md-1">
        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav ms-auto">
            <!----------------------->
            <!-- DROPDOWN          -->
            <!----------------------->
            <li class="nav-item me-3">
              <a>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDarkDropdown"
                  aria-controls="#navbarNavDarkDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div
                  class="collapse navbar-collapse"
                  id="navbarNavDarkDropdown"
                >
                  <!------------------------->
                  <!-- BUTTON (USERNAME)   -->
                  <!------------------------->
                  <li class="nav-item dropdown mt-3">
                    <a>
                      <button
                        class="btn dropdown-toggle btn-dark"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {{ user_name }}
                      </button>
                      <!--------------------->
                      <!-- DROPDOWN ITEMS  -->
                      <!--------------------->
                      <ul class="dropdown-menu dropdown-menu-dark mt-0">
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'combatCharacters',
                              }"
                            >
                              Characters
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'combatRaces',
                              }"
                            >
                              Races
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'combatSpells',
                              }"
                            >
                              Spells
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'combatArtefacts',
                              }"
                            >
                              Artefacts
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'manageCombat',
                                params: currentCampaignSlug
                                  ? { slug: currentCampaignSlug }
                                  : {},
                                query: { popup: 'party-skills' },
                              }"
                            >
                              Party Skills
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'manageCombat',
                                params: currentCampaignSlug
                                  ? { slug: currentCampaignSlug }
                                  : {},
                                query: { popup: 'party-runes' },
                              }"
                            >
                              Party Runes
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'manageCombat',
                                params: currentCampaignSlug
                                  ? { slug: currentCampaignSlug }
                                  : {},
                                query: { popup: 'party-rolls' },
                              }"
                            >
                              Party Rolls
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: 'manageCombat',
                                params: currentCampaignSlug
                                  ? { slug: currentCampaignSlug }
                                  : {},
                                query: { popup: 'log' },
                              }"
                            >
                              Log
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{ name: 'campaignsView' }"
                            >
                              Exit Campaign
                            </router-link>
                          </a>
                        </li>
                        <li class="submenu submenu-md dropend">
                          <a
                            class="dropdown-item dropdown-toggle"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onclick="event.stopPropagation();"
                          >
                            About
                          </a>
                          <ul class="dropdown-menu">
                            <li>
                              <a class="dropdown-item">{{ getVersion }}</a>
                            </li>
                          </ul>
                        </li>
                        <div class="dropdown-divider"></div>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{ name: 'logoutView' }"
                            >
                              Logout
                            </router-link>
                          </a>
                        </li>
                      </ul>
                    </a>
                  </li>
                </div>
              </a>
            </li>
            <!--------------------->
            <!-- AVATAR          -->
            <!--------------------->
            <li class="nav-item me-2">
              <img
                v-bind:src="avatar_image"
                height="70"
                width="70"
                class="rounded-circle bb-img"
                alt="Avatar"
              />
            </li>
            <!-- end items -->
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
//========================================================
// scripts
//---------
import { mapGetters } from 'vuex'
import ScoreBoard from '@/components/ScoreBoard.vue'

export default {
  name: 'CombatNavbarComponent',
  //========================================================
  // components
  //------------
  components: {
    'score-board': ScoreBoard,
  },
  //========================================================
  // data
  //------
  data() {
    return {
      arena_round: 0,
      arena_action: 0,
      view_round: 0,
      unused_action_count: 0,
      user_name: '',
      // arena_name: "",
      arena_status: '',
      arena_locked: false,
      avatar_image: null,
      version: '',
    }
  },
  //========================================================
  // computed
  //----------
  computed: {
    ...mapGetters('combat', {
      getVersion: 'getVersion',
    }),
    arena_locked_label() {
      if (this.arena_locked) {
        return 'Locked'
      } else {
        return 'Unlocked'
      }
    },
    arena_active_combatants() {
      return this.getActiveCombatantCount()
    },
    arena_inactive_combatants() {
      return this.getInactiveCombatantCount()
    },
    arena_sub_status() {
      return this.getArenaSubStatus()
    },
    currentCampaignSlug() {
      return this.getCampaign()?.slug || ''
    },
    which_round() {
      const round =
        this.view_round > this.arena_round
          ? 'Future Round'
          : this.view_round < this.arena_round && this.view_round !== 0
            ? 'Previous Round'
            : ''
      return round
    },
    isNotCurrent() {
      return this.view_round !== this.arena_round && this.view_round !== 0
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
    }),
    ...mapGetters('combat', {
      getInactiveCombatantCount: 'getInactiveCombatantCount',
      getActiveCombatantCount: 'getActiveCombatantCount',
      getUnusedActionCount: 'getUnusedActionCount',
      getViewRound: 'getViewRound',
      getArenaSubStatus: 'getArenaSubStatus',
      getCampaign: 'getCampaign',
    }),
    //-------------------
    // get campaign handler
    //-------------------
    getCampaignHandler() {
      const campaign = this.getCampaign()

      if (!campaign) {
        return false
      }

      this.arena_round = campaign.round
      this.arena_action = campaign.action
      this.arena_status = campaign.status
      this.arena_locked = campaign.locked

      return true
    },
    //---------------------------------
    // get unused action count handler
    //---------------------------------
    getUnusedActionCountHandler() {
      this.unused_action_count = this.getUnusedActionCount()
    },
    //----------------------
    // user profile handler
    //----------------------
    userProfileHandler() {
      let userProfile = this.getUserProfile()
      this.user_name = userProfile.user_name
      this.avatar_image = userProfile.avatar_image
    },
  },
  //========================================================
  // mounted
  //---------
  mounted() {
    //-------------------
    // get campaign details
    //-------------------
    this.getCampaignHandler()
    //-------------------------
    // get unused action count
    //-------------------------
    this.getUnusedActionCountHandler()
    //-------------------
    // load user details
    //-------------------
    this.userProfileHandler()
    //-----------------------------
    // emitter - update scoreboard
    //-----------------------------
    this.emitter.on('update-scoreboard', () => {
      this.getCampaignHandler()
      this.getUnusedActionCountHandler()
      this.view_round = this.getViewRound()
    })
  },
}
</script>

<style scoped>
.bb-navbar {
  position: relative;
  z-index: 2100;
}

.bb-navbar .dropdown-menu {
  z-index: 2101;
}

.bb-combat-navbar.orange {
  background-color: rgba(204, 139, 18, 0.904);
}
</style>
